import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function NameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const validFullName = /^([a-zA-Z0-9](\s?[a-zA-Z0-9])*)+$|^([ئ0-9لإيءألآلاؤآا-ى](\.?\s?[ئ0-9لإيءألآلاؤآا-ى])*)+$/gi.test(control.value);
      return !validFullName ? {namePattern: false} : null;
    };
}